module.exports = __webpack_public_path__ + "static/th-4912302e9f224bb5aa8ca8c64eb479c0.jpg";